import CustomisableWidgetPopover from '@intercom/embercom-composer/components/customisable-widget-popover';
export default CustomisableWidgetPopover;
